import React from 'react'

import { ActivityStatus } from '../../../../components'
import CommonTypesBaseView from './CommonTypesBaseView'

const columns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true
  },
  {
    id: 'is_active',
    label: 'Active',
    sortable: true,
    cellRenderer: (datum) => <ActivityStatus active={Boolean(datum)} />
  }
]

function LeadSourcesView() {
  return (
    <CommonTypesBaseView
      title="Lead Sources"
      category="Lead Sources"
      columns={columns}
    />
  )
}

export default LeadSourcesView
